import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-4 sf-pro"
}
const _hoisted_2 = { class: "text-xl font-bold pt-4 mb-2" }
const _hoisted_3 = { class: "whitespace-pre-line" }

import AccordionComponent from "@/components/accordion/AccordionComponent.vue";
import { inject, ref, watch } from "vue";
import { DestinyMatrix, DestinyMatrixKeysEnum } from "@/types/destinyMatrix";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProgramsAccordion',
  props: /*@__PURE__*/_mergeModels({
    matrix: {},
    hasPremiumAccess: { type: Boolean }
  }, {
    "modelValue": { type: Boolean, ...{ default: false } },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;
const isOpen = _useModel<boolean>(__props, "modelValue");
const getDescription =
  inject<(key: DestinyMatrixKeysEnum) => Promise<never>>("getDescription");

const { t } = useI18n();

watch(
  () => props.matrix,
  () => (description.value = undefined)
);

const description = ref();

async function getData() {
  if (!props.hasPremiumAccess) {
    isOpen.value = false;
  }
  if (!description.value && props.matrix && getDescription) {
    description.value = await getDescription(DestinyMatrixKeysEnum.PROGRAMS);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AccordionComponent, {
    type: "white",
    onOpened: getData,
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    isBlocked: !__props.hasPremiumAccess
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.programs")), 1)
    ]),
    "faq-content": _withCtx(() => [
      (description.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(description.value, (program, key) => {
              return (_openBlock(), _createElementBlock("div", { key: key }, [
                _createElementVNode("p", _hoisted_2, _toDisplayString(program["title"]), 1),
                _createElementVNode("div", _hoisted_3, _toDisplayString(program["desc"]), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    "collapse-text-btn": _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.collapse")), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "isBlocked"]))
}
}

})